import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // Importer le routeur
import i18n from './i18n'; // Importer i18n

createApp(App)
  .use(router) // Appliquer le routeur
  .use(i18n) // Appliquer i18n
  .mount('#app');
